"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vimeoPlayer = void 0;
var player_1 = __importDefault(require("@vimeo/player"));
var vimeoPlayer = function () {
    var playerContainers = document.querySelectorAll('.c-video.-vimeo');
    if (!playerContainers.length) {
        return;
    }
    playerContainers.forEach(function (container) {
        var videoWrapper = container.querySelector('.c-video_wrapper');
        var videoId = Number(container.dataset.video);
        if (videoId && videoWrapper) {
            new player_1.default(videoWrapper, {
                id: videoId,
                controls: true,
                autopause: false,
                autoplay: false,
                muted: false,
                loop: false,
                quality: 'auto',
            });
        }
    });
};
exports.vimeoPlayer = vimeoPlayer;
(0, exports.vimeoPlayer)();
